/* eslint-disable no-undef */
APP.LazyImages = function (imgsSelector) {
  imgsSelector = imgsSelector || 'img[data-src]';
  // this.lazyImages = Array.prototype.slice.call(document.querySelectorAll(".column.image img"));
  this.lazyImages = Array.prototype.slice.call(document.querySelectorAll(imgsSelector));

  if (window.innerWidth < APP.conf.breakPoints.tablet2Min) {
    window.addEventListener('scroll', this._lazyLoad.bind(this));
    this._lazyLoad();
  }
};

APP.LazyImages.prototype._inViewPort = function (image) {
  var coords = image.getBoundingClientRect();
  return (coords.top >= 0 && coords.left >= 0 && coords.top) <= (window.innerHeight || document.documentElement.clientHeight);
};

APP.LazyImages.prototype._lazyLoad = function () {
  this.lazyImages.forEach(
    function (image) {
      var imageDataSrc = image.getAttribute('data-src');
      if (this._inViewPort(image) && image.src !== imageDataSrc) {
        image.src = imageDataSrc;
      }
    }.bind(this)
  );
};
